import { useState, useEffect } from "react";
import { useLoadScript } from "@react-google-maps/api";
import usePlacesAutoComplete, { getGeocode, getLatLng } from "use-places-autocomplete";
import { Combobox, ComboboxInput, ComboboxPopover, ComboboxList, ComboboxOption } from "@reach/combobox";
import i18n from "../../../i18n";
import './styles.css';
import { setDefaults } from "react-geocode";
import config from '../../../constants/settings';

export default function Places({ selected, setSelected, setHiddenOne, disabled, id, placeholder, setTitleAdress, typeAddress, selectedAddress, setSelectedAddress, setRowsScale, rowsScale, addressRow, setHiddenSecond, servicesView, editAddress }) {
  
  const [libraries] = useState(['places']);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: config.google.secret,
    libraries: libraries,
    language: "es",
    region: "mx",
  });

  const [valuePlace, setValuePlace] = useState(null);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setDefaults({
      key: config.google.secret,
      language: "es",
      region: "mx",
    });
  }, []);

  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions
  } = usePlacesAutoComplete({
    requestOptions: {
      componentRestrictions: { country: 'mx' },
    },
    debounce: 300,
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
  
    handleResize();
    window.addEventListener('resize', handleResize);
  
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    switch(typeAddress){
      case "predefined":
        console.log("selectedAddress", selectedAddress)
        setValuePlace(selectedAddress.description || i18n.t("WriteDefaultaddress"));
        setValue(!editAddress ? selectedAddress.description : "");
        break;
      case "origin":
        setValuePlace(selectedAddress.description);
        break;
      case "destiny":
        setValuePlace(selectedAddress.description);
        break;
      case "array":
        setValuePlace(addressRow?.address?.description || i18n.t("WriteAdditionalAddress"));
        setValue(addressRow?.address?.description || "");
        break;
      default:
        setValuePlace(i18n.t("WriteAddress"));
        setValue('');
    }
  }, [selectedAddress, rowsScale, typeAddress, editAddress, addressRow]);

  const handleSelect = async (address) => {
    const results = await getGeocode({ address });
    const { lat, lng } = await getLatLng(results[0]);
    setValue(address, false);

    if (typeAddress === 'predefined' || typeAddress === 'origin' || typeAddress === 'destiny') {
      checkName(address);
      clearSuggestions();
      let onSelectedAddress = { ...selectedAddress };

      onSelectedAddress.description = address;

      if (onSelectedAddress.location) {
        onSelectedAddress.location.lat = lat;
        onSelectedAddress.location.lon = lng;
      } else {
        onSelectedAddress.location = { lat, lon: lng };
      }

      setSelectedAddress(onSelectedAddress);
      setSelected({ lat, lng });
    } else {
      let arr = [...rowsScale];
      let fAddress = arr.filter(function(opt) {
        return opt.id === addressRow?.id;
      }).shift();
      
      if (fAddress) {
        arr.splice(arr.indexOf(fAddress), 1);
        fAddress.address.description = address;
        fAddress.address.location.lat = lat;
        fAddress.address.location.lon = lng;
        arr.push(fAddress);
        arr.sort((a, b) => (a.id > b.id) ? 1 : -1);
        setRowsScale([...arr]);
      }
    }
  };

  const checkName = (address) => {
    switch(typeAddress){
      case 'predefined':
        setTitleAdress(i18n.t("TitleAddress", { typeAddress: i18n.t("Predefined"), address: address }));
        break;
      case 'origin':
        setTitleAdress(i18n.t("TitleAddress", { typeAddress: i18n.t("Origin"), address: address }));
        break;
      case 'destiny':
        setTitleAdress(i18n.t("TitleAddress", { typeAddress: i18n.t("Destiny"), address: address }));
        break;
      default:
        setTitleAdress('');
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('mobile-overlay')) {
      setIsMobilePopupOpen(false);
    }
  };  

  const onFocusAddress = (e) => {
    if (isMobile) {
      setIsMobilePopupOpen(true);
    }
    switch(typeAddress){
      case 'predefined':
        setTitleAdress(i18n.t("TitleAddress", { typeAddress: i18n.t("Predefined"), address: selectedAddress?.description }));
        hiddenArrayAddress();
        setHiddenOne(false);
        break;
      case 'array':
        findHiddenRow();
        break;
      case 'destiny':
        setTitleAdress(i18n.t("TitleAddress", { typeAddress: i18n.t("Destiny"), address: selectedAddress?.description }));
        setHiddenOne(false);
        setHiddenSecond(true);
        break;
      case 'origin':
        setTitleAdress(i18n.t("TitleAddress", { typeAddress: i18n.t("Origin"), address: selectedAddress?.description }));
        setHiddenOne(false);
        setHiddenSecond(true);
        break;
      default:
        break;
    }
  };  

  const hiddenArrayAddress = () => {
    let arr = [...rowsScale];
    arr.forEach(function(opt) {
      opt.addresssMap = true;
    });
    setRowsScale([...arr]);
  };

  const findHiddenRow = () => {
    servicesView ? setHiddenOne(false) : setHiddenOne(true);
    let arr = [...rowsScale];
    let fAddress = arr.filter(function(opt) {
      opt.addresssMap = opt.id !== addressRow?.id ? true : false;
      return opt.id === addressRow?.id;
    }).shift();

    if (fAddress) {
      arr.splice(arr.indexOf(fAddress), 1);
      fAddress.addresssMap = false;
      fAddress.editRow = false;
      arr.push(fAddress);
      arr.sort((a, b) => (a.id > b.id) ? 1 : -1);
      setRowsScale([...arr]);
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    if (inputValue === "") {
      setSelectedAddress({
        ...selectedAddress,
        description: "",
        location: null,
      });
      setSelected({ lat: null, lng: null });
    }
  };

  if (!isLoaded) return <div>Loading..</div>;

return (
  <>
    {isMobile && isMobilePopupOpen && (
      <div className="mobile-overlay" onClick={handleOverlayClick}>
        <div className="mobile-popup">
          <Combobox onSelect={handleSelect}>
            <ComboboxInput 
              value={value}
              placeholder={valuePlace}
              id={id}
              onFocus={(e) => onFocusAddress(e)}
              onChange={handleInputChange}
              disabled={disabled}
              className="combobox-input w-100 form-control"
              autoFocus
            />
            <ComboboxPopover className="places">
              <ComboboxList>
                {status === 'OK' && 
                  data.map((item, key) => (
                    <div className="list-places" key={key}>
                      <ComboboxOption className="place" key={item.place_id} value={item.description} />
                    </div>
                  ))
                }
              </ComboboxList>
            </ComboboxPopover>
          </Combobox>
        </div>
      </div>
    )}
    {(!isMobile || !isMobilePopupOpen) && (
      <Combobox onSelect={handleSelect}>
        <ComboboxInput 
          value={value}
          placeholder={valuePlace}
          id={id}
          onFocus={(e) => onFocusAddress(e)}
          onChange={handleInputChange}
          disabled={disabled}
          className="combobox-input w-100 form-control"
        />
        <ComboboxPopover className="places">
          <ComboboxList>
            {status === 'OK' && 
              data.map((item, key) => (
                <div className="list-places" key={key}>
                  <ComboboxOption className="place" key={item.place_id} value={item.description} />
                </div>
              ))
            }
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
    )}
  </>
);
}
